import { render, staticRenderFns } from "./FormNewPartner.vue?vue&type=template&id=4e32912e&scoped=true&"
import script from "./FormNewPartner.vue?vue&type=script&lang=js&"
export * from "./FormNewPartner.vue?vue&type=script&lang=js&"
import style0 from "./FormNewPartner.vue?vue&type=style&index=0&id=4e32912e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e32912e",
  null
  
)

export default component.exports